import { AgencyHiringConstantMapping } from "./agencyHiringConstantMapping";

/**
 * MENA Agency Organization Name to Domain Name mappings, as they appear in ROMP
 * Includes India and other MENA region agencies
 */
export const AGENCY_HIRING_CONSTANT_MAPPING_MENA: AgencyHiringConstantMapping =
  {
    "AASAANJOBS PVT LTD": "aasaanjobs",
    "NOVHO CAREERS PVT LTD": "novho-careers",
    "QUESS CORP LIMITED": "quess-corp",
    "Watermelon Management Services Pvt Ltd": "watermelon",
    "BSHR CONSULTANT PRIVATE LIMITED": "bshr",
    "Global Innovsource Solutions": "innovsource",
    "PSN Supply Chain Solution PVT LTD": "psn",
    "SPNN Business Services Pvt Ltd": "spnn",
    "TDS Placements & Services Private Limited": "tds-placements",
    "Million Minds": "million-minds",
    "JARIKART Pvt Ltd": "jarikart",
    "Needs Manpower Support Services Pvt Ltd": "needs-manpower",
    "S&IB Services": "sib-services",
    "Weavings Manpower Solutions Pvt. Ltd.": "weavings",
    "SAFETY WINGS PRIVATE LIMITED": "safetywings",
    Buzzworks: "buzzworks",
    "Team HR GSA Private Limited": "teamhr",
    "OM Unique Private Limited": "om-enterprises",
    "SAAR Integrated Services Private Limited": "saar",
    "ASSORT STAFFING SERVICES PRIVATE LIMITED": "assortstaffing",
    "Assort 1 Corp Services Limited": "assort1",
    "Sanjeera Restaurant & Recruitment Services Pvt. Ltd": "sanjeera",
    "INTEXLOGISTICS INDIA PRIVATE LIMITED": "intexlogistics",
    "H1 HR SOLUTIONS PRIVATE LIMITED": "h1",
    "YASHIKA GROWTH PRIVATE LIMITED": "yashikagrowth",
    "Sunrising Staffing Services Pvt Ltd": "sunrisingstaffing",
  };
